<rect
    x="0.666667"
    y="0.666667"
    width="48.6667"
    height="48.6667"
    rx="24.3333"
    stroke="#E6E8EC"
    stroke-width="1.33333"
/>
<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M33.3332 17.7083H16.6665C16.0912 17.7083 15.6248 18.1747 15.6248 18.75V31.25C15.6248 31.8253 16.0912 32.2917 16.6665 32.2917H33.3332C33.9085 32.2917 34.3748 31.8253 34.3748 31.25V18.75C34.3748 18.1747 33.9085 17.7083 33.3332 17.7083ZM16.6665 15.625C14.9406 15.625 13.5415 17.0241 13.5415 18.75V31.25C13.5415 32.9759 14.9406 34.375 16.6665 34.375H33.3332C35.0591 34.375 36.4582 32.9759 36.4582 31.25V18.75C36.4582 17.0241 35.0591 15.625 33.3332 15.625H16.6665Z"
    fill="#777E91"
/>
<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17.95 20.1666C18.3183 19.7246 18.9751 19.6649 19.417 20.0332L24.3333 24.1301C24.7196 24.452 25.2807 24.452 25.667 24.1301L30.5833 20.0332C31.0253 19.6649 31.6821 19.7246 32.0504 20.1666C32.4187 20.6085 32.359 21.2654 31.917 21.6337L27.0008 25.7306C25.8419 26.6963 24.1585 26.6963 22.9996 25.7306L18.0833 21.6337C17.6414 21.2654 17.5817 20.6085 17.95 20.1666Z"
    fill="#777E91"
/>
